import React, { useEffect, useState } from "react";
import { useNavigate, useMatch, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Paper } from "@components/paper";
import { PageWrapper } from "@containers/PageWrapper/pageWrapper";
import ContentWrapper from "./../../components/contentWrapper/contentWrapper";
import {
  BreadCrumb,
  TrackingTitle,
  StatusContainer,
  DeclinedReferral,
} from "./components/index";
import { Error } from "./containers";
import { animateNavigationToNewPath } from "@utils/helpers/navigators";
import { TRACKING_STATUS } from "../../constants/commonConstants";
import { Loader } from "@components/loader/loader";
import actions from "@redux/statusTracking/actions";
import { pathBuilder } from "./helpers";
import { TRACKING_STEPS, TRACKING_STEPS_MOBILE } from "./trackingConstants";

export const Tracking = ({ children = undefined }) => {
  const { value: {status, referralConsent, daysUntilExpiry}, fetchStatusDataFailed } = useSelector(
    (state) => state.trackingStatus
  );
  const queryString = useSelector((state) => state.StartUp.queryString);

  const { id } = queryString;

  const navigate = useNavigate();
  
  const path = "/status";
  const dispatch = useDispatch();

  const [isStatusLoaded, setIsStatusLoaded] = useState(false);
  const [showErrorPage, setShowErrorPage] = useState(false);

  let currentStep = null;
  let statusThemeColor = "";
  let showIndicatorStatus = false;
  let trackingPath = "";

  switch (status) {
    case "ReadyForAssessment":
      trackingPath = pathBuilder(path, TRACKING_STATUS.IN_SCHEDULE, id);
      currentStep = 0;
      statusThemeColor = "mainThemeColour";
      break;
    case "Declined":
      trackingPath = pathBuilder(path, TRACKING_STATUS.DECLINED, id);
      currentStep = 2;
      statusThemeColor = "declinedThemeColour";
      showIndicatorStatus = true;
      break;
    case "InAssessment":
      trackingPath = pathBuilder(path, TRACKING_STATUS.IN_ASSESSMENT, id);
      currentStep = 1;
      statusThemeColor = "mainThemeColour";
      break;
    case "Approved":
      trackingPath = pathBuilder(path, TRACKING_STATUS.APPROVED_ESIGN, id);
      currentStep = 2;
      statusThemeColor = "mainThemeColour";
      showIndicatorStatus = true;
      break;
    case "Cancelled":
      trackingPath = pathBuilder(path, TRACKING_STATUS.CANCELLED, id);
      break;
    case "Funded":
    case "Idle":
      trackingPath = pathBuilder(path, TRACKING_STATUS.FUNDED, id);
      statusThemeColor = "white";
      break;
    case "Expired":
      trackingPath = pathBuilder(path, TRACKING_STATUS.EXPIRED, id, queryString);
      break;
    default:
      currentStep = 0;
      statusThemeColor = "mainThemeColour";
      break;
  }

  const doNotShowBreadcrumb = 
    status === "Funded" ||
    status === "Cancelled" ||
    status === "Expired" ||
    status === "Idle";

  const doNotShowTitle = status === "Idle" || status === "Funded";

  const declineIsActive = status === "Declined";

  
  useEffect(() => {
    if (status) {
      setIsStatusLoaded(true);
      animateNavigationToNewPath(navigate, trackingPath);
    } else {
      dispatch(actions.fetchStatusData());
      setShowErrorPage(fetchStatusDataFailed);
    }
  }, [status, setIsStatusLoaded, navigate, trackingPath, dispatch, setShowErrorPage, fetchStatusDataFailed]);

  return (
    <PageWrapper>
      <Paper>
        {isStatusLoaded ? (
          <ContentWrapper>
            {!doNotShowTitle && <TrackingTitle />}
            {!doNotShowBreadcrumb && 
              <BreadCrumb
                statusThemeColor={statusThemeColor}
                currentStep={currentStep}
                steps={TRACKING_STEPS}
                stepsMobile={TRACKING_STEPS_MOBILE}
                showIndicatorStatus={showIndicatorStatus}
                daysUntilExpiry={daysUntilExpiry}
                declineIsActive={declineIsActive}
              />}
            <StatusContainer statusThemeColor={statusThemeColor} >{children}</StatusContainer>
            {status === "Declined" && (
              <DeclinedReferral referralConsent={referralConsent} />
            )}
          </ContentWrapper>
        ) : (
            <Loader loading={!showErrorPage}/>
        )}
        {showErrorPage ? <Error /> : ""}
      </Paper>
    </PageWrapper>
  );
};

export default Tracking;
